import getEnvironment from './get.environment';

export const redirectFromSpanishSite = () => {
    if (!['production', 'implementation'].includes(getEnvironment()))
        return;
    if (window.location.hostname.includes('es.medicare'))
        window.location.href = `https://medicare.gov${window.location.pathname}?Lang=es-mx`;
    if (window.location.hostname.includes('es.imp.medicare'))
        window.location.href = `https://imp.medicare.gov${window.location.pathname}?Lang=es-mx`;
};